import React from "react";
import { Container } from "reactstrap";
import "./footer.css";

export default class FooterComponent extends React.Component {
  render() {
    return (
      <footer className="app-footer compact">
      <div className="footer-bar">
        <img
          className="footer-logo"
          src={require("../../../common/images/amplofly-white.png")}
          alt="AmploFly 4.0"
        />
        <ul className="social-list">
          <li><a href="#" aria-label="Twitter"><i className="fab fa-twitter" /></a></li>
          <li><a href="#" aria-label="Facebook"><i className="fab fa-facebook-square" /></a></li>
          <li><a href="#" aria-label="LinkedIn"><i className="fab fa-linkedin" /></a></li>
        </ul>
        <div className="footer-links">
          <a href="/terms" target="_blank" rel="noopener noreferrer">Terms</a>
          <span className="sep">•</span>
          <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy</a>
        </div>
        <p className="copyright">&copy; {new Date().getFullYear()} Amplo (AmploFly 4.0)</p>
      </div>
    </footer>
    
    );
  }
}
